import { randomBytes } from 'crypto';
import * as BIP39 from 'bip39';
const HDKey = require('hdkey');
export var mnemonic;
(function (mnemonic) {
    // see https://github.com/satoshilabs/slips/blob/master/slip-0044.md
    const VET_DERIVATION_PATH = `m/44'/818'/0'/0`;
    /** generate BIP39 mnemonic words */
    function generate() {
        return BIP39.generateMnemonic(128, randomBytes).split(' ');
    }
    mnemonic.generate = generate;
    /**
     * check if the given mnemonic words have valid checksum
     * @param words mnemonic words
     */
    function validate(words) {
        return BIP39.validateMnemonic(words.join(' '));
    }
    mnemonic.validate = validate;
    /**
     * derive private key from mnemonic words according to BIP32.
     * the derivation path is defined at https://github.com/satoshilabs/slips/blob/master/slip-0044.md
     */
    function derivePrivateKey(words) {
        const seed = BIP39.mnemonicToSeed(words.join(' '));
        const hdKey = HDKey.fromMasterSeed(seed);
        return hdKey.derive(VET_DERIVATION_PATH + '/0').privateKey;
    }
    mnemonic.derivePrivateKey = derivePrivateKey;
})(mnemonic || (mnemonic = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW5lbW9uaWMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY3J5L21uZW1vbmljLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxRQUFRLENBQUE7QUFFcEMsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUE7QUFDOUIsTUFBTSxLQUFLLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQyxDQUFBO0FBRTlCLE1BQU0sS0FBVyxRQUFRLENBMEJ4QjtBQTFCRCxXQUFpQixRQUFRO0lBQ3JCLG9FQUFvRTtJQUNwRSxNQUFNLG1CQUFtQixHQUFHLGlCQUFpQixDQUFBO0lBRTdDLG9DQUFvQztJQUNwQztRQUNJLE9BQU8sS0FBSyxDQUFDLGdCQUFnQixDQUFDLEdBQUcsRUFBRSxXQUFXLENBQUMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDOUQsQ0FBQztJQUZlLGlCQUFRLFdBRXZCLENBQUE7SUFFRDs7O09BR0c7SUFDSCxrQkFBeUIsS0FBZTtRQUNwQyxPQUFPLEtBQUssQ0FBQyxnQkFBZ0IsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUE7SUFDbEQsQ0FBQztJQUZlLGlCQUFRLFdBRXZCLENBQUE7SUFFRDs7O09BR0c7SUFDSCwwQkFBaUMsS0FBZTtRQUM1QyxNQUFNLElBQUksR0FBRyxLQUFLLENBQUMsY0FBYyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQTtRQUNsRCxNQUFNLEtBQUssR0FBRyxLQUFLLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFBO1FBQ3hDLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxtQkFBbUIsR0FBRyxJQUFJLENBQUMsQ0FBQyxVQUFVLENBQUE7SUFDOUQsQ0FBQztJQUplLHlCQUFnQixtQkFJL0IsQ0FBQTtBQUNMLENBQUMsRUExQmdCLFFBQVEsS0FBUixRQUFRLFFBMEJ4QiJ9